import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

export const selectorRequirementExpirationDate = (
  requirement: PayeeRequirement
) => {
  return requirement.expiresAt;
};
